import classNames from 'classnames';
import { Fragment } from 'react';

import { DisplayTime } from 'common/display-state/display-time.js';
import { ComponentLink } from 'common/link/link-component.js';
import { INote, RenderNotes } from 'common/render-notes.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IconWithData } from 'components-modules/park-conditions.js';
import { IModule } from 'redux-state/layout/types.js';
import { LinkTarget } from 'types/navigation.js';

interface IData {
  heading?: string;
  text: string;
}

interface IForecast {
  forecast: Array<IData>;
  fzl?: string;
  windStatement?: string;
  issuedAt?: string;
  location: string;
}

interface IMountainForecast {
  forecasts: Array<IForecast>;
  notes: Array<INote>;
}

export const MountainForecast = (props: IModule<IMountainForecast>) => {
  const {
    config: { forecasts, notes, link },
  } = props;

  return (
    <Tile dataModule="mountain-forecast" {...props}>
      <div className="Tile-body">
        <TileBodyHeaderV2 isDrawer={props.isDrawer} modulePath={props.modulePath} config={props.config} />
        {forecasts.map((forecast, index) => (
          <Forecast key={index} forecast={forecast} isFirst={index === 0} />
        ))}
        {notes && (
          <div className="u-pT-sm u-mT-sm u-bT-1">
            <RenderNotes notes={notes} />
          </div>
        )}
        {link && (
          <div className="u-mT-sm u-bT-1 u-pT-sm u-flex u-flexJustifyCenter u-flexAlignItemsCenter">
            <ComponentLink url={link.url} urlClasses="Link u-linkClean" target={link.target ?? LinkTarget.SELF}>
              <small className="u-textBold">{link.label}</small>
            </ComponentLink>
          </div>
        )}
      </div>
    </Tile>
  );
};

const Forecast = ({
  isFirst,
  forecast: { forecast, fzl, location, windStatement, issuedAt },
}: {
  forecast: IForecast;
  isFirst?: boolean;
}) => (
  <>
    <h3 className={classNames('h2', { 'u-pT-sm u-bT-1': !isFirst })}>{location}</h3>

    {forecast.map(({ heading, text }, index) => (
      <Fragment key={index}>
        {heading && <h4>{heading}</h4>}
        <p>{text}</p>
      </Fragment>
    ))}

    {windStatement && <IconWithData className="u-mB-sm" icon="wind" label="wind" val={windStatement} />}
    {/* icon="freezing-level-dark"  */}
    {fzl && <IconWithData icon="freezing-level" label="freezing level" val={fzl} className="svg-fill-textSlate" />}

    {issuedAt && (
      <p className="fineprint u-textGrey u-mB-0">
        <DisplayTime date={issuedAt} />
      </p>
    )}
  </>
);
